"use client";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import Image from "next/image";
import NewsList from "@/components/utils/NewsList";
import InViewAnimation from "@/components/utils/InViewAnimation";
import Link from "next/link";

export default function PageComponent({posts}) {
  return (
    <main className="page page-everyone">
      <div className="container-m">
        <InViewAnimation fadeOnly={true}>
          <section className="section section-kv">
            <div className="kv-pic pcOnly">
              <img src="/assets/img/for-everyone/kv-pic.jpg" alt="" />
            </div>
            <div className="kv-title-holder">
              <div className="shoulder">
                <span className="en small">For Everyone</span>
                <span className="bold">みなさまへ</span>
              </div>
              <h1 className="h1-title bold">
                Next Green Revolutionが<br />
                始まります。<br />
                皆さんも是非、ご参加ください。
              </h1>
              <div className="kv-pic spOnly">
                <img src="/assets/img/for-everyone/kv-pic.jpg" alt="" />
              </div>
              <div className="pcOnly"></div>
            </div>
          </section>
        </InViewAnimation>

        <section className="section section-1" id="section-1">
          <InViewAnimation fadeOnly={true}>
            <picture className="logo-ngr-break">
              <source srcSet="/assets/img/common/ngr_break.svg" media="(min-width: 1024px)" />
              <source srcSet="/assets/img/common/ngr_break-sp.svg" media="(max-width: 1024px)" />
              <img src="/assets/img/common/ngr_break.svg" alt="NEXT GREEN REVOLUTION" />
          </picture>
          </InViewAnimation>
          <InViewAnimation>
            <div className="block-text n1 bold">
              Next Green Revolution<br />
              これは、みなさんと一緒につくる<br className="spOnly" />新しい食と農の運動です。
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="pic round n1">
              <img src="/assets/img/for-everyone/gallery/pic-1.jpg" alt="" />
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="pic round n2">
              <img src="/assets/img/for-everyone/gallery/pic-2.jpg" alt="" />
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="block-text bold">
              垣根を越えて、さまざまな人がつながり、<br className="spOnly" />ワクワクしたり、<br className="pcOnly" />ちょっと感動したり、<br className="spOnly" />なんだか安心できたり、<br />
              そんな体験を共有できる活動と<br className="spOnly" />なるはずです。
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="pic round n3">
              <img src="/assets/img/for-everyone/gallery/pic-3.jpg" alt="" />
            </div>
            </InViewAnimation>
          <InViewAnimation>
            <div className="pic round n4">
              <img src="/assets/img/for-everyone/gallery/pic-4.jpg" alt="" />
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="pic round n5">
              <img src="/assets/img/for-everyone/gallery/pic-5.jpg" alt="" />
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="pic round n6">
              <img src="/assets/img/for-everyone/gallery/pic-6.jpg" alt="" />
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="block-text bold">
              まずは今回、<br />
              食べる人とつくる人がつながり、<br />
              「おいしい」も「地球にいい」も叶えていく仕組みとして<br className="pcOnly" />
              <Link className="pink scaleHover opacity" href="/vegetables/"><span className="inner">Next Green Vegetables</span></Link>をつくりました。
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="block-text bold">
              おいしく健康な野菜を食べる事が、<br />
              サステナブルな農業の応援になると<br className="spOnly" />信じて。
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="pic round n7">
              <img src="/assets/img/for-everyone/gallery/pic-7.jpg" alt="" />
            </div>
          </InViewAnimation>
          <InViewAnimation>
            <div className="block-text bold">
              今後、Next Green Revolutionを通じて、<br />
              みんなが繋がる場がさまざまな形で<br className="spOnly" />生まれていきます。<br />
              ご期待ください。<br />
              そして、みなさんの参加を<br className="spOnly" />心よりお待ちしています！<br />
              Join us!
            </div>
          </InViewAnimation>
        </section>
      </div>

      {posts.length > 0 && (
        <>
          <div className="separator-asterisk en">*</div>

          <div className="container-m">
            <section className="section section-method-latestcase">
              <div className="section-title-holder">
                <h2 className="section-title bold">
                  BGの活動
                </h2>
              </div>
              <div className="container-xs grayCard">
                <NewsList posts={posts} />
                <Link href="/news/implementation/everyone/" className="button-link button-round scaleHover size-s">
                  <span className="inner">すべての事例をみる</span>
                </Link>
              </div>
            </section>
          </div>
        </>
      )}
    </main>
  );
}
